import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/button';

export const CTASection = () => {
  return (
    <section
      className="relative py-20 lg:py-32 overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_maritime-connect-2/artifacts/eh576k8r_Copilot_20251106_002554.png')`,
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-navy/90" />

      {/* Content */}
      <div className="rsl-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Text */}
          <div>
            <span className="text-safety-orange font-mono text-xs tracking-widest uppercase">
              Ready to Ship?
            </span>
            <h2 className="text-4xl lg:text-5xl font-black text-white uppercase tracking-tight mt-2 mb-6">
              Let's Move Your <br />
              <span className="text-safety-orange">Cargo Forward</span>
            </h2>
            <p className="text-white/80 text-lg mb-8 max-w-lg">
              Get a free quote today and discover why businesses trust RSL for their global shipping needs. Our team is ready to create a customized solution for your cargo.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/quote">
                <Button
                  className="cta-primary h-14 px-8"
                  data-testid="cta-get-quote-btn"
                >
                  Get Free Quote
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button
                  variant="outline"
                  className="cta-secondary h-14 px-8"
                  data-testid="cta-contact-btn"
                >
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>

          {/* Right - Contact Card */}
          <div className="bg-white p-8 lg:p-10">
            <h3 className="text-2xl font-bold text-navy mb-6">
              Speak With Our Team
            </h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-safety-orange/10 p-3">
                  <Phone className="w-6 h-6 text-safety-orange" />
                </div>
                <div>
                  <p className="font-mono text-xs text-slate-500 uppercase tracking-wider mb-1">
                    Call Us Directly
                  </p>
                  <a
                    href="tel:+14153299700"
                    className="text-xl font-bold text-navy hover:text-safety-orange transition-colors"
                    data-testid="cta-phone"
                  >
                    (415) 329-9700
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-safety-orange/10 p-3">
                  <Mail className="w-6 h-6 text-safety-orange" />
                </div>
                <div>
                  <p className="font-mono text-xs text-slate-500 uppercase tracking-wider mb-1">
                    Email Us
                  </p>
                  <a
                    href="mailto:quotes@robertshipping.com"
                    className="text-xl font-bold text-navy hover:text-safety-orange transition-colors"
                    data-testid="cta-email"
                  >
                    quotes@robertshipping.com
                  </a>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200">
              <p className="text-sm text-slate-600">
                <span className="font-bold text-navy">Office Hours:</span><br />
                Monday - Friday: 8:00 AM - 6:00 PM PST<br />
                Saturday: 9:00 AM - 2:00 PM PST
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
